import QPdfviewer from '@quasar/quasar-app-extension-qpdfviewer/src/component/QPdfviewer';
export default (function (_ref) {
  var Vue = _ref.Vue;
  Vue.component('q-pdfviewer', QPdfviewer);
});